import cookieService, { COOKIE_KEYS } from './cookieService';
import sessionStorageService, {
  SESSION_STORAGE_KEYS,
} from './sessionStorageService';

export default {
  get confirmedPasscodeSecureLinkId() {
    return sessionStorageService.getItem(
      SESSION_STORAGE_KEYS.CONFIRMED_PASSCODE_SECURE_LINK_ID,
    );
  },

  set confirmedPasscodeSecureLinkId(secureLinkId: string) {
    sessionStorageService.setItem(
      SESSION_STORAGE_KEYS.CONFIRMED_PASSCODE_SECURE_LINK_ID,
      secureLinkId,
    );
  },

  removeConfirmedPasscodeSecureLinkId() {
    sessionStorageService.removeItem(
      SESSION_STORAGE_KEYS.CONFIRMED_PASSCODE_SECURE_LINK_ID,
    );
  },

  get ownerRedirectedFromSL() {
    return cookieService.getItem(COOKIE_KEYS.OWNER_REDIRECTED_FROM_SL);
  },

  redirectedFromSL() {
    cookieService.setItem(COOKIE_KEYS.OWNER_REDIRECTED_FROM_SL, 'true');
  },

  removeOwnerRedirectedFromSL() {
    cookieService.removeItem(COOKIE_KEYS.OWNER_REDIRECTED_FROM_SL);
  },
};
